import React, { useCallback, useContext } from "react";
import EntityList from "../../EntityList/EntityList";
import { QuestionnaireFormContext } from "../QuestionnaireFormContext";

function NestedQuestionnairesList({
  config,
  entities,
  loading,
  entityError,
  entityResult,
  handleCreate,
  handleEdit,
  nested,
  onToggleListItem,
  onDeleteListItem,
  parentFormValues,
  onChange,
}) {
  const { currentDependerType: contextDependerType } = useContext(QuestionnaireFormContext);
  const dependerType =
    (parentFormValues && parentFormValues.dependers) || contextDependerType || "EXTRA";
  const isRoomStayMaxReached =
    dependerType === "ROOMSTAY_CHECKOUT" && (entities || []).length >= 1;
  // HU3: only the Guest Form lets the hotelier order its questions.
  const canReorder = dependerType === "GUEST_FORM";

  const { name, entityName, validation, fields, renderers, sorting, reorder } = config;

  const handleToggle = useCallback(
    ({ event, field, entity, idx }) => {
      event.preventDefault();
      event.stopPropagation();
      onToggleListItem({ id: entity.id, entity, idx, field });
    },
    [onToggleListItem]
  );

  const handleDelete = useCallback(
    ({ event, entity, idx }) => {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      return onDeleteListItem({ id: entity.id, entity, idx });
    },
    [onDeleteListItem]
  );

  // HU3: reorder the array, renumber `position`, save with the questionnaire.
  const handleReorder = useCallback(
    ({ oldIndex, newIndex } = {}) => {
      const list = [...(entities || [])];
      if (
        oldIndex == null ||
        newIndex == null ||
        oldIndex === newIndex ||
        oldIndex < 0 ||
        newIndex < 0 ||
        oldIndex >= list.length ||
        newIndex >= list.length
      ) {
        return;
      }
      const [moved] = list.splice(oldIndex, 1);
      list.splice(newIndex, 0, moved);
      const reordered = list.map((entity, index) => ({ ...entity, position: index + 1 }));
      onChange({ field: "fields", value: reordered });
    },
    [entities, onChange]
  );

  return (
    <EntityList
      loading={loading}
      entityName={entityName}
      entities={entities}
      validation={validation}
      renderers={renderers.list}
      name={name}
      fields={fields}
      onToggle={handleToggle}
      onDelete={handleDelete}
      // sortBy=position routes the drag through onSort; onReorder is only passed
      // so the drag handle renders (it never fires — handleReorder guards args).
      onSort={handleReorder}
      onReorder={canReorder ? handleReorder : undefined}
      entityError={entityError}
      entityResult={entityResult}
      handleCreate={isRoomStayMaxReached ? undefined : handleCreate}
      handleEdit={handleEdit}
      nested={nested}
      sorting={sorting}
      reorder={reorder}
    />
  );
}

export default NestedQuestionnairesList;
